import { render } from "./BurreauEquipe.vue?vue&type=template&id=3d0f952f&scoped=true"
import script from "./BurreauEquipe.vue?vue&type=script&lang=js"
export * from "./BurreauEquipe.vue?vue&type=script&lang=js"

import "./BurreauEquipe.vue?vue&type=style&index=0&id=3d0f952f&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d0f952f"]])

export default __exports__